import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { SIGNO_FECHA } from '../../../core/model/inventories';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-date-time-button',
  templateUrl: './date-time-button.component.html',
  styleUrls: ['./date-time-button.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateTimeButtonComponent),
      multi: true
    }
  ]
})
export class DateTimeButtonComponent implements OnInit, ControlValueAccessor {

  @Input() name: string;
  @Input() fechaMin: Date;
  @Input() disabledDate: boolean;
  @Input() showTitle = true;
  @Input() withPeriod = false;
  @Input() showCalendarOnly = false;

  @Input() set value(val) {
    if (val !== undefined && this.val !== val) {
      this.val = val;
      this.onChange(val);
      this.onTouch(val);
    }
  }

  @Output() valueChange = new EventEmitter<Date>();

  @Output() dateTimeChange = new EventEmitter<Date>();
  @Output() periodChange = new EventEmitter<string>();

  language: string;

  signDates = SIGNO_FECHA;

  val = '';
  onChange: any = () => { };
  onTouch: any = () => { };


  constructor(private dateTimeAdapter: DateTimeAdapter<any>) {}

  ngOnInit() {
    this.language = this.getDateTimeAdapter();
    this.dateTimeAdapter.setLocale(this.language);
    if (this.withPeriod) {
      this.periodChange.emit(this.signDates['greather']);
     }
  }

  onDateChange(value) {
    if (value.length == 'MM-DD-YYYY HH:mm'.length && this.language == 'es-ES') {
      const day = value.substr(0, 2);
      const month = value.substring(3, 5);
      const dateString = month + '-' + day + value.substring(5);
      const date = new Date(dateString);
      this.valueChange.emit(date);
      console.log(date);
    }
  }

  dateTimeHasChanged(value: Date) {
    this.dateTimeChange.emit(value);
    if (!this.withPeriod) {
      this.valueChange.emit(value);
     }
  }

  private getDateTimeAdapter(): any {
    const language = localStorage.getItem('idioma');
    if (language == 'en') {
      return 'en-US';
    }
    return 'es-ES';
  }

  setPeriod(event) {
    this.periodChange.emit(this.signDates[event.target.value]);
  }

  getSignDates() {
    return Object.keys(this.signDates);
  }

  writeValue(value: any) {
    this.value = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

}
